import { render, staticRenderFns } from "./periodos.vue?vue&type=template&id=2b8cbb36&scoped=true"
import script from "./periodos.vue?vue&type=script&lang=js"
export * from "./periodos.vue?vue&type=script&lang=js"
import style0 from "./periodos.vue?vue&type=style&index=0&id=2b8cbb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8cbb36",
  null
  
)

export default component.exports